export const dataTypes = {
    pset: {
        heading: 'Pharmacogenomics',
        set: 'Pset'
    },
    toxicoset: {
        heading: 'Toxicogenomic',
        set: 'ToxicoSet'
    },
    radioset: {
        heading: 'Radiogenomic',
        set: 'RadioSet'
    },
    xevaset: {
        heading: 'Xenographic Pharmacogenomics',
        set: 'XevaSet'
    },
    clinical_icb: {
        heading: 'Immune Checkpoint Blockade',
        set: ''
    },
    clinicalgenomics: {
        heading: 'Clinical Genomics',
        set: 'Clinical Genomics Set'
    },
    radiomicset: {
        heading: 'Radiomic',
        set: 'RadiomicSet'
    },
    annotations: {
        heading: 'Annotation',
        set: 'AnnotationSet'
    }
};
